import React, { useState } from 'react';
import { useGameStore } from '../../stores/gameStore';
import { useUserStore } from '../../stores/userStore';

export function SocialScreen() {
  const setScreen = useGameStore(s => s.setScreen);
  const user = useUserStore(s => s.user);
  const [activeTab, setActiveTab] = useState('friends');
  const [messageInput, setMessageInput] = useState('');

  const tabs = [
    { id: 'friends', label: 'Friends', count: user?.friends.length || 0 },
    { id: 'messages', label: 'Messages', count: 0 },
    { id: 'notifications', label: 'Notifications', count: useUserStore.getState().unreadCount },
    { id: 'find', label: 'Find Players' },
  ];

  const mockFriends = [
    { id: '1', username: 'ShadowStrike', status: 'online', game: 'Playing Shatterpoint' },
    { id: '2', username: 'PhantomAce', status: 'online', game: 'In Menu' },
    { id: '3', username: 'NeonBlade', status: 'offline', game: '' },
    { id: '4', username: 'CrimsonFury', status: 'in-game', game: 'Team Deathmatch' },
  ];

  const mockMessages = [
    { from: 'ShadowStrike', content: 'Good game earlier!', time: '2 min ago', read: false },
    { from: 'PhantomAce', content: 'Want to team up for ranked?', time: '15 min ago', read: true },
  ];

  const mockNotifications = useUserStore(s => s.notifications);

  return (
    <div className="w-full h-full flex flex-col bg-cf-black">
      <div className="flex items-center justify-between px-6 py-4 border-b border-cf-border">
        <h2 className="text-xl font-bold text-cf-white">Social</h2>
        <button onClick={() => setScreen('menu')} className="cf-btn-secondary text-xs">Back</button>
      </div>

      <div className="flex flex-1 overflow-hidden">
        <div className="w-48 border-r border-cf-border p-3 space-y-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center justify-between ${
                activeTab === tab.id
                  ? 'bg-cf-cyan/10 text-cf-cyan border border-cf-cyan/20'
                  : 'text-cf-muted hover:text-cf-text hover:bg-cf-dark'
              }`}
            >
              <span>{tab.label}</span>
              {'count' in tab && (tab.count ?? 0) > 0 && (
                <span className="px-1.5 py-0.5 rounded-full bg-cf-cyan/20 text-cf-cyan text-[10px] font-bold">
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>

        <div className="flex-1 overflow-y-auto">
          {activeTab === 'friends' && (
            <div className="p-4 space-y-2">
              {mockFriends.map((friend) => (
                <div key={friend.id} className="cf-panel p-3 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-cf-dark flex items-center justify-center font-bold text-sm text-cf-cyan">
                    {friend.username.charAt(0)}
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-sm text-cf-white">{friend.username}</div>
                    <div className="text-xs text-cf-muted">
                      {friend.game || (friend.status === 'online' ? 'Online' : 'Offline')}
                    </div>
                  </div>
                  <div className={`w-2.5 h-2.5 rounded-full ${
                    friend.status === 'online' ? 'bg-cf-green' :
                    friend.status === 'in-game' ? 'bg-cf-amber' : 'bg-cf-muted/40'
                  }`} />
                  <button className="cf-btn-secondary text-xs py-1 px-2">Invite</button>
                </div>
              ))}
              {mockFriends.length === 0 && (
                <div className="text-center py-16 text-cf-muted">
                  <div className="text-3xl mb-2">👥</div>
                  <p>No friends yet. Find players to add!</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'messages' && (
            <div className="flex flex-col h-full">
              <div className="flex-1 overflow-y-auto p-4 space-y-2">
                {mockMessages.map((msg, i) => (
                  <div key={i} className={`cf-panel p-3 ${!msg.read ? 'border-cf-cyan/30 bg-cf-cyan/5' : ''}`}>
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-semibold text-sm text-cf-cyan">{msg.from}</span>
                      <span className="text-[10px] text-cf-muted">{msg.time}</span>
                    </div>
                    <p className="text-sm text-cf-text">{msg.content}</p>
                  </div>
                ))}
                {mockMessages.length === 0 && (
                  <div className="text-center py-16 text-cf-muted">
                    <div className="text-3xl mb-2">💬</div>
                    <p>No messages</p>
                  </div>
                )}
              </div>
              <div className="p-3 border-t border-cf-border">
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={messageInput}
                    onChange={(e) => setMessageInput(e.target.value)}
                    placeholder="Type a message..."
                    className="cf-input flex-1"
                  />
                  <button className="cf-btn-primary text-xs">Send</button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'notifications' && (
            <div className="p-4 space-y-2">
              {mockNotifications.length > 0 ? mockNotifications.map((notif) => (
                <div key={notif.id} className={`cf-panel p-3 ${!notif.read ? 'border-cf-cyan/30 bg-cf-cyan/5' : ''}`}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-semibold text-sm text-cf-white">{notif.title}</span>
                    <span className="text-[10px] text-cf-muted">{new Date(notif.createdAt).toLocaleTimeString()}</span>
                  </div>
                  <p className="text-xs text-cf-muted">{notif.message}</p>
                </div>
              )) : (
                <div className="text-center py-16 text-cf-muted">
                  <div className="text-3xl mb-2">🔔</div>
                  <p>No notifications</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'find' && (
            <div className="p-4 space-y-4">
              <input type="text" placeholder="Search players..." className="cf-input" />
              <div className="text-center py-8 text-cf-muted text-sm">
                Enter a username to find and add players
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
